<div class="handles">
    <ng-content></ng-content>
    <app-handle (click)="close()">
        <i class="fa fa-times"></i>
    </app-handle>
</div>

<app-panel class="panel">
    <i icon class="fas fa-eraser"></i>
    <div title>Gum</div>
    <app-control-diameter (changed)="onDiameterChange($event)" [value]="size$ | async" [options]="options" [cssVariableScale]="0.5"></app-control-diameter>
</app-panel>
